import {
  AssignmentLifecycleStage,
  Task,
  TaskAssignmentStatus,
  TaskLifecycleStage,
  TaskStatus,
} from 'edrolo/domains/coursePortal/types/Task';
import Waffle from 'edrolo/utils/Waffle';
import { isAfter } from 'date-fns';

export const getTaskMeta = (task: Task) => {
  const readOnly = (): boolean => {
    switch (task.resolved_stage) {
      case TaskLifecycleStage.SCHEDULED:
        return true;
      case TaskLifecycleStage.OPEN:
        return true;
      case TaskLifecycleStage.CLOSED:
        return true;
      case TaskLifecycleStage.ARCHIVED:
        return true;
      default:
        return false;
    }
  };

  const legacyReadOnly = (): boolean => {
    switch (task.status) {
      case TaskStatus.OPEN:
        return true;
      case TaskStatus.CLOSED:
        return true;
      default:
        return false;
    }
  };

  const hasStarted = task.task_assignments.some(
    (ta) =>
      ta.resolved_stage === AssignmentLifecycleStage.IN_PROGRESS ||
      ta.resolved_stage === AssignmentLifecycleStage.COMPLETED
  );

  const legacyHasStarted = task.task_assignments.some(
    (ta) => ta.completion_status !== TaskAssignmentStatus.NOT_STARTED
  );

  const isCompleted = task.resolved_stage === TaskLifecycleStage.CLOSED;

  const isClosed = task.resolved_stage === TaskLifecycleStage.CLOSED; // TODO: remove this stage as it conflicts with isCompleted. we can get this value from getTaskMeta
  const taskMgmtIsActive = Waffle.flag_is_active('task_mgmt');

  const inProgress = hasStarted && !isCompleted && !isClosed;

  const legacyInProgress = legacyHasStarted;

  const now = new Date();
  const startDate = task.start_datetime ? new Date(task.start_datetime) : null;
  const legacyIsScheduled: boolean =
    (task.status === TaskStatus.OPEN && startDate && isAfter(startDate, now)) ??
    false;

  const isOpen = taskMgmtIsActive
    ? task.resolved_stage === TaskLifecycleStage.OPEN
    : task.status === TaskStatus.OPEN;

  const hasCompletedNew: boolean = task.task_assignments?.some(
    (task_assignment) =>
      task_assignment.resolved_stage === AssignmentLifecycleStage.COMPLETED
  );

  const hasCompletedLegacy: boolean = task.task_assignments?.some(
    (task_assignment) =>
      task_assignment.completion_status === TaskAssignmentStatus.COMPLETED
  );

  const hasCompleted = taskMgmtIsActive ? hasCompletedNew : hasCompletedLegacy;

  const hasInsights: boolean = isOpen || hasCompleted;

  return {
    readOnly: taskMgmtIsActive ? readOnly() : legacyReadOnly(),
    isDraft: taskMgmtIsActive
      ? task.resolved_stage === TaskLifecycleStage.DRAFT
      : task.status === TaskStatus.DRAFT,
    isScheduled: taskMgmtIsActive
      ? task.resolved_stage === TaskLifecycleStage.SCHEDULED
      : legacyIsScheduled,
    isOpen,
    isClosed: taskMgmtIsActive
      ? task.resolved_stage === TaskLifecycleStage.CLOSED
      : false,
    inProgress: taskMgmtIsActive ? inProgress : legacyInProgress,
    hasStarted: taskMgmtIsActive ? hasStarted : legacyHasStarted,
    hasStartDate: task.start_datetime ? true : false,
    hasInsights,
  };
};
